import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=4a281068&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=js&"
export * from "./Referral.vue?vue&type=script&lang=js&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=4a281068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a281068",
  null
  
)

export default component.exports